<template src="./formazione.html"></template>

<script>
import { get_corsi, get_edizioni, delete_edizione, get_attestatiAzienda, download_attestato } from "@/api/api.formazione.js";
import { get_listaClienti } from "@/api/api.dati.js";
import GestioneCorsi from "@/components/formazione/GestioneCorsi.vue";
import EsportaCorsiSvolti from "@/components/formazione/EsportaCorsiSvolti.vue";

export default {
    components: { GestioneCorsi, EsportaCorsiSvolti },

    data: () => ({
        loading: false,

        edizioni: [],
        corsi: [],
        aziende: [],
        attestati: [],

        filtro: {
            CorsoId: null,
            Anno: null,
            CompanyCode: "",
            Stato: "",
            TipoCertificazione: "",
        },

        dialogCorsi: false,
        dialogExport: false,
        anni: [],

        headersEdizioni: [
            { text: "Corso", value: "nomeBreveCorso", sortable: false },
            { text: "Certificato", value: "tipoCertificazione", sortable: false },
            { text: "Data", value: "data", sortable: false },
            { text: "Ore", value: "ore", sortable: false },
            { text: "Modalita'", value: "modalita", sortable: false },
            { text: "Partecipanti", value: "numeroPartecipanti", sortable: false },
            { text: "Stato", value: "stato", sortable: false },
            { text: "Azioni", value: "azioni", sortable: false },
        ],

        headersAttestati: [
            { text: "Corso", value: "nomeBreveCorso", sortable: false },
            { text: "Data", value: "data", sortable: false },
            { text: "Partecipante", value: "nomeCompleto", sortable: false },
            { text: "Stato", value: "stato", sortable: false },
            { text: "Data rilascio", value: "dataRilascio", sortable: false },
            { text: "Attestato", value: "azioni", sortable: false },
        ],
    }),

    methods: {
        // Un'edizione programmata la cui data e' gia' passata va confermata (corso concluso): la si evidenzia.
        daConfermare(item) {
            if (item.stato === "Confermato" || !item.data) return false;
            return new Date(item.data.substring(0, 10)) < new Date(new Date().toISOString().substring(0, 10));
        },

        etichettaStato(item) {
            if (item.stato === "Confermato") return "Confermato";
            return this.daConfermare(item) ? "Da confermare" : "Programmato";
        },

        coloreStato(item) {
            if (item.stato === "Confermato") return "success";
            return this.daConfermare(item) ? "orange" : "blue lighten-4";
        },

        async caricaDati() {
            this.loading = true;
            try {
                if (this.role === "admin") {
                    const [resEdizioni, resCorsi, resAziende] = await Promise.all([
                        get_edizioni(this.filtro),
                        get_corsi(),
                        get_listaClienti({ Cliente: true, Gruppo: "Tutti" }),
                    ]);
                    this.edizioni = resEdizioni.data;
                    this.corsi = resCorsi.data;
                    this.aziende = resAziende.data;
                } else if (this.role === "utente") {
                    const res = await get_attestatiAzienda();
                    this.attestati = res.data.map((a) => ({ ...a, nomeCompleto: `${a.nome} ${a.cognome}` }));
                }
            } catch (error) {
                this.$toast.alert("Errore durante il caricamento dei dati");
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        nuovaEdizione() {
            this.$router.push({ path: "/formazione/edizione/nuova" });
        },

        apriEdizione(item) {
            this.$router.push({ path: "/formazione/edizione/" + item.edizioneId });
        },

        async eliminaEdizione(item) {
            let confirm = await this.$confirm.open(
                "Elimina edizione",
                "Eliminare l'edizione di <b>" + item.nomeBreveCorso + "</b>? Aziende e partecipanti inseriti andranno persi."
            );
            if (!confirm) return;

            const res = await delete_edizione(item.edizioneId);
            if (res.data === "OK") {
                this.$toast.info("Edizione eliminata");
                await this.caricaDati();
            } else {
                this.$toast.alert(res.data);
            }
        },

        async scaricaAttestato(item) {
            try {
                const res = await download_attestato(item.partecipanteId);
                const blob = new Blob([res.data], { type: "application/pdf" });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `Attestato_${item.nomeCompleto}_${item.nomeBreveCorso}.pdf`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                this.$toast.alert("Attestato non disponibile");
            }
        },

        formattaData(data) {
            if (!data) return "";
            try {
                return this.$i2kFunctions.formatISODate(data.substring(0, 10));
            } catch {
                return data;
            }
        },

        generaAnni() {
            const annoCorrente = new Date().getFullYear();
            const lista = [];
            for (let a = annoCorrente + 1; a >= annoCorrente - 5; a--) lista.push(a);
            return lista;
        },
    },

    created() {
        if (this.role !== "admin" && this.role !== "utente") this.$router.push({ path: "/" });
    },

    async mounted() {
        if (!this.role) {
            await this.$store.dispatch("user/userInfo");
        }
        this.anni = this.generaAnni();
        this.caricaDati();
    },

    computed: {
        role() {
            return this.$store.getters["user/getRole"];
        },
    },
};
</script>
